import { useValidateOrderStatus } from './useValidateOrderStatus';

/**
 * Screen-route validation based on the payment status of the order.
 * If the screen route is not in line with the status of the payment,
 * the customer is redirected to the correct screen to continue.
 * Logic is in the`useValidateOrderStatus` hook.
 */
export var ValidateOrderStatus = function ValidateOrderStatus() {
  useValidateOrderStatus();
  return null;
};